import { Component, Input, OnInit, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Application } from 'app/shared/services/app/application/application.model';
import { RoleType } from 'app/shared/services/user/user-application-properties.model';
import { DashboardService } from 'app/shared/services/dashboard/dashboard.service';
import { Session } from '../../services/session/session.service';
import { ActiveUser } from 'app/shared/services/user/active-user.model';

@Component({
  selector: 'tog-app-bubble',
  templateUrl: 'application-bubble.template.html',
  styleUrls: ['application-bubble.scss']
})
export class ApplicationBubbleComponent implements OnInit {
  hasUserPermission: boolean;
  RoleType: RoleType;
  hasPermission: boolean = false;
  backgroundColor: string;
  name: string;
  style: any = {};
  statusOptions: any = this._ds.statusOptions;
  user: ActiveUser;
  localUserRole: any;

  @Input() application: Application;

  @Output('bubbleClicked') bubbleClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output('archiveClicked') archiveClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output('editStatusClicked') editStatusClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(private _router: Router,
              private _session: Session,
              private _ds: DashboardService) {}

  ngOnInit() {
    this._session.user()
    .then((user: ActiveUser) => {
      this.user = user;
      this.localUserRole = this.user.roles.filter(role => role.application.sys_name == this.application.sys_name)[0].level;
      if (this.localUserRole >= RoleType.Admin) { this.hasPermission = true }
      if (this.localUserRole >= RoleType.Owner) { this.hasUserPermission = true }
      if (this.application.logo) {
        this.style['background-image'] = 'url(' + this.application.logo + ')';
        this.style['background-color'] = 'white';
      }
    });
  }

  goToUsersPage(e: any) {
    if (this.application.isActive && this.hasUserPermission) {
      e.stopPropagation();
      this._router.navigateByUrl(this.application.navRoot + '/users');
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/application-bubble/application-bubble.component.ts